import styled from 'styled-components';

import Error from 'components/DriverMap/Error/container';

import { gridSizes, media, zIndexses } from 'utils/style';

export default styled(Error)`
  position: fixed;
  height: 100%;
  width: 50%;
  z-index: ${zIndexses.driverMapError};
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--grey900);
  color: var(--white);

  ${media.lessThan('medium')`
    width: 40%;
    `}

  .text {
    text-align: center;
    margin: 0 ${gridSizes('XL')};
  }
`;
